module.exports = __webpack_public_path__ + "static/media/sudhir.ae0e893b.png";